import api from "../api/axios";

export const createPaymentInfo = async (orderId, paymentInfoArray) => {
  const data = { order_id: Number(orderId), payment_info: paymentInfoArray };
  const response = await api.post("/payments/create", data);
  return response.data;
};

export const fetchPaymentsByOrder = async (orderId) => {
  const response = await api.get(`/payments/${orderId}`);
  return response.data;
};

export const updatePaymentInfo = async (id, updates) => {
  const response = await api.patch(`/payments/${id}`, updates);
  return response.data;
};

export const deletePaymentInfo = async (id) => {
  const response = await api.delete(`/payments/${id}`);
  return response.data;
};

export const uploadPaymentImage = async (paymentInfoId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("payment_info_id", paymentInfoId);
  const response = await api.post("/payments/images", formData);
  return response.data;
};

export const fetchPaymentImages = async (paymentInfoId) => {
  const response = await api.get(`/payments/images/${paymentInfoId}`);
  return response.data;
};

export const deletePaymentImage = async (imageId) => {
  const response = await api.delete(`/payments/images/${imageId}`);
  return response.data;
};
